/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Known values of {@link StringIndexType} that the service accepts. */
export var KnownStringIndexType;

(function (KnownStringIndexType) {
  KnownStringIndexType["TextElements"] = "textElements";
  KnownStringIndexType["UnicodeCodePoint"] = "unicodeCodePoint";
  KnownStringIndexType["Utf16CodeUnit"] = "utf16CodeUnit";
})(KnownStringIndexType || (KnownStringIndexType = {}));
/** Known values of {@link ApiVersion} that the service accepts. */


export var KnownApiVersion;

(function (KnownApiVersion) {
  KnownApiVersion["TwoThousandTwentyTwo0630Preview"] = "2022-06-30-preview";
})(KnownApiVersion || (KnownApiVersion = {}));
/** Known values of {@link DocumentPageKind} that the service accepts. */


export var KnownDocumentPageKind;

(function (KnownDocumentPageKind) {
  KnownDocumentPageKind["Document"] = "document";
  KnownDocumentPageKind["Sheet"] = "sheet";
  KnownDocumentPageKind["Slide"] = "slide";
  KnownDocumentPageKind["Image"] = "image";
})(KnownDocumentPageKind || (KnownDocumentPageKind = {}));
/** Known values of {@link LengthUnit} that the service accepts. */


export var KnownLengthUnit;

(function (KnownLengthUnit) {
  KnownLengthUnit["Pixel"] = "pixel";
  KnownLengthUnit["Inch"] = "inch";
})(KnownLengthUnit || (KnownLengthUnit = {}));
/** Known values of {@link SelectionMarkState} that the service accepts. */


export var KnownSelectionMarkState;

(function (KnownSelectionMarkState) {
  KnownSelectionMarkState["Selected"] = "selected";
  KnownSelectionMarkState["Unselected"] = "unselected";
})(KnownSelectionMarkState || (KnownSelectionMarkState = {}));
/** Known values of {@link ParagraphRole} that the service accepts. */


export var KnownParagraphRole;

(function (KnownParagraphRole) {
  KnownParagraphRole["PageHeader"] = "pageHeader";
  KnownParagraphRole["PageFooter"] = "pageFooter";
  KnownParagraphRole["PageNumber"] = "pageNumber";
  KnownParagraphRole["Title"] = "title";
  KnownParagraphRole["SectionHeading"] = "sectionHeading";
  KnownParagraphRole["Footnote"] = "footnote";
})(KnownParagraphRole || (KnownParagraphRole = {}));
/** Known values of {@link DocumentTableCellKind} that the service accepts. */


export var KnownDocumentTableCellKind;

(function (KnownDocumentTableCellKind) {
  KnownDocumentTableCellKind["Content"] = "content";
  KnownDocumentTableCellKind["RowHeader"] = "rowHeader";
  KnownDocumentTableCellKind["ColumnHeader"] = "columnHeader";
  KnownDocumentTableCellKind["StubHead"] = "stubHead";
  KnownDocumentTableCellKind["Description"] = "description";
})(KnownDocumentTableCellKind || (KnownDocumentTableCellKind = {}));
/** Known values of {@link DocumentFieldType} that the service accepts. */


export var KnownDocumentFieldType;

(function (KnownDocumentFieldType) {
  KnownDocumentFieldType["String"] = "string";
  KnownDocumentFieldType["Date"] = "date";
  KnownDocumentFieldType["Time"] = "time";
  KnownDocumentFieldType["PhoneNumber"] = "phoneNumber";
  KnownDocumentFieldType["Number"] = "number";
  KnownDocumentFieldType["Integer"] = "integer";
  KnownDocumentFieldType["SelectionMark"] = "selectionMark";
  KnownDocumentFieldType["CountryRegion"] = "countryRegion";
  KnownDocumentFieldType["Signature"] = "signature";
  KnownDocumentFieldType["Array"] = "array";
  KnownDocumentFieldType["Object"] = "object";
  KnownDocumentFieldType["Currency"] = "currency";
  KnownDocumentFieldType["Address"] = "address";
})(KnownDocumentFieldType || (KnownDocumentFieldType = {}));
/** Known values of {@link DocumentSignatureType} that the service accepts. */


export var KnownDocumentSignatureType;

(function (KnownDocumentSignatureType) {
  KnownDocumentSignatureType["Signed"] = "signed";
  KnownDocumentSignatureType["Unsigned"] = "unsigned";
})(KnownDocumentSignatureType || (KnownDocumentSignatureType = {}));
/** Known values of {@link DocumentBuildMode} that the service accepts. */


export var KnownDocumentBuildMode;

(function (KnownDocumentBuildMode) {
  KnownDocumentBuildMode["Template"] = "template";
  KnownDocumentBuildMode["Neural"] = "neural";
})(KnownDocumentBuildMode || (KnownDocumentBuildMode = {}));
/** Known values of {@link OperationKind} that the service accepts. */


export var KnownOperationKind;

(function (KnownOperationKind) {
  KnownOperationKind["DocumentModelBuild"] = "documentModelBuild";
  KnownOperationKind["DocumentModelCompose"] = "documentModelCompose";
  KnownOperationKind["DocumentModelCopyTo"] = "documentModelCopyTo";
})(KnownOperationKind || (KnownOperationKind = {}));